import { useMemo } from 'react';

import { AssetsContext } from './Assets.context';

import { Styles } from '../components/article/Styles';
import { useAssets, useLoadFonts } from './Assets.hooks';

export function Assets({ children }: AssetProps) {
	const { styles, fonts, isLoading, error } = useAssets();
	useLoadFonts(fonts);
	const stylesMap = useMemo(() => new Styles(styles).styles, [styles]);

	return (
		<AssetsContext.Provider
			value={{
				styles,
				isLoading,
				stylesMap,
				error,
				fonts,
			}}
		>
			{children}
		</AssetsContext.Provider>
	);
}

interface AssetProps {
	children: string | JSX.Element | JSX.Element[];
}
